import React, { FunctionComponent, useState, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';

type Props = {
  isModalOpen: boolean;
  redirectUrl: string;
  isCarefully: boolean;
  isRequestPathRecruitmentOrEventOrTvOrFollow?: boolean;
  handleToggleRegisterModal: () => void;
  handleChangeModal: (from: 'login' | 'register') => void;
  lineIcon: string;
};

export const Component: FunctionComponent<Props> = ({
  isModalOpen,
  redirectUrl,
  isCarefully,
  isRequestPathRecruitmentOrEventOrTvOrFollow,
  handleToggleRegisterModal,
  handleChangeModal,
  lineIcon
}) => {
  const buildOauthUrl = (provider: string): string => {
    let base = '';
    const params: string[] = [];
    switch (provider) {
      case 'line':
        base = '/oauths/line';
        if (isRequestPathRecruitmentOrEventOrTvOrFollow) {
          params.push(`redirect_url=${encodeURIComponent(redirectUrl)}`);
        }
        break;
      case 'facebook':
        base = '/oauths/facebook';
        if (isRequestPathRecruitmentOrEventOrTvOrFollow) {
          params.push(`redirect_url=${encodeURIComponent(redirectUrl)}`);
        } 
        if (isCarefully) {
          params.push('registration_status=careful');
        }
        break;
      case 'apple':
        base = '/oauths/apple';
        if (isRequestPathRecruitmentOrEventOrTvOrFollow) {
          params.push(`redirect_url=${encodeURIComponent(redirectUrl)}`);
        }
        if (isCarefully) {
          params.push('registration_status=careful');
        }
        break;
      case 'mail':
        base = isCarefully ? '/users/new/information' : '/users/new';
        if (isRequestPathRecruitmentOrEventOrTvOrFollow) {
          params.push(`redirect_url=${encodeURIComponent(redirectUrl)}`);
        }
        break;
    }
    return params.length ? `${base}?${params.join('&')}` : base;
  };

  const handleOauthsLinkClick = (provider: string) => {
    const url = buildOauthUrl(provider);
    window.location.href = url;
  };

  return (
    <Presentation
      isModalOpen={isModalOpen}
      isCarefully={isCarefully}
      handleToggleRegisterModal={handleToggleRegisterModal}
      handleChangeModal={handleChangeModal}
      handleOauthsLinkClick={handleOauthsLinkClick}
      lineIcon={lineIcon}
    />
  );
};
